"use client"

import { useEffect, useState } from 'react'
import { isVoiceInputAvailable } from '@/lib/voice/support'

let cached: boolean | null = null

/**
 * Доступен ли голосовой ввод (флаг + поддержка браузера). До монтирования — false,
 * чтобы SSR и первый клиентский рендер совпадали.
 */
export function useVoiceAvailable(): boolean {
  const [available, setAvailable] = useState(false)
  useEffect(() => {
    if (cached === null) cached = isVoiceInputAvailable()
    setAvailable(cached)
  }, [])
  return available
}
